import useSWR from 'swr'
import type { SWRConfiguration } from 'swr'

import { useGTMFetchErrorHandling } from './useGTMFetchErrorHandling'
import { config } from 'lib/config'
import { AccountsData, GTM_API_LINK, accountsSchema, gtmFetcher, gtmSWRErrorHandler } from 'lib/gtm'

export function useGTMAccounts(options?: SWRConfiguration) {
	const accountsFetcher = (url: string) => gtmFetcher({ url, schema: accountsSchema })

	const { data, mutate, error } = useSWR<AccountsData>(`${GTM_API_LINK}/accounts`, accountsFetcher, {
		...options,
		revalidateIfStale: false,
		onErrorRetry(_error, key, config, revalidate, revalidateOpts) {
			gtmSWRErrorHandler(_error, revalidate, revalidateOpts)
		},
		// Just a small hack to make tests faster
		...(config.isTest && {
			errorRetryInterval: 100,
		}),
	})

	useGTMFetchErrorHandling(error)

	return {
		accounts: data ? data.account ?? [] : null,
		mutateAccounts: mutate,
	}
}
